import React, { lazy } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import Loadable from '../ui-component/Loadable';
import MainLayout from '../layout';
import AuthGuard from '../utils/route-guard/AuthGuard'
import { matchPath } from 'react-router-dom';


const LandingPage = Loadable(lazy(() => import('../views/pages/LandingPage')));
const Logout = Loadable(lazy(() => import('../views/pages/authentication/Logout')));
const UserProfiles = Loadable(lazy(() => import('../Components/UserProfileList')));
const ClientList = Loadable(lazy(() => import('../Components/clientList')));
const DepartmentList = Loadable(lazy(() => import('../Components/Department')));
const VendorList = Loadable(lazy(() => import('../Components/VendorList')));
const OrganizationProfileList = Loadable(lazy(() => import('../Components/ImplementerProfileList')));
const JobDescription = Loadable(lazy(() => import('../Components/JobDescription')))
const ImpDepartmentList = Loadable(lazy(() => import('../Components/ImpDepartments')));
const LinkedInCallback = Loadable(lazy(() => import('../Components/LinkedInCallback')));
const PortalConfig = Loadable(lazy(() => import('../Components/PortalConfig')));
const CandidateProfile = Loadable(lazy(() => import('../Components/CandidateProfile')));
const MatchedProfilesPage = Loadable(lazy(() => import('../Components/MatchedProfilesPage')));
const ShortlistDetailsForm = Loadable(lazy(() => import('../Components/ShortlistDetailsForm')));
const CandidateActionPage = Loadable(lazy(() => import('../Components/CandidateActionPage')));
const ScheduleInterview = Loadable(lazy(() => import('../Components/ScheduleInterview')));
const MatchedProfilesCandidate = Loadable(lazy(() => import('../Components/MatchedProfilesCandidate')));
const AuditLogs = Loadable(lazy(() => import('../Components/AuditLogs')));
const MailReadStatus = Loadable(lazy(() => import('../Components/MailReadStatus')));
const ScrapingProgressTable = Loadable(lazy(() => import('../Components/ScrapingProgressTable')));

const MainRoutes = () => {
    console.log("main route");
    const location = useLocation();
    const validPaths = [
        '/logout',
        '/dashboard',
        '/user_profiles',
        '/client_list',
        '/department_list',
        '/vendor_list',
        '/implementer_list',
        '/job_description',
        '/imp_departments',
        '/linkedin/callback',
        '/portal_config',
        '/candidate_profile',
        '/jd/:jdId/matched-profiles',
        '/shortlist-details/:token',
        '/candidate-action/:token',
        '/schedule-interview/:token',
        '/resume/:resume_id/matched-profiles-candidate',
        '/audit_logs',
        '/mail_read_status',
        '/scraping_progress_table',
    ];
    const isValidPath = validPaths.some((path) =>
        matchPath({ path, end: true }, location.pathname)
    );

    if (!isValidPath) {
        return null;
    }
    return (
        <MainLayout>
            <AuthGuard>
                <Routes location={location} key={location.pathname}>
                    <Route path="/dashboard" element={<LandingPage />} />
                    <Route path="/user_profiles" element={<UserProfiles />} />
                    <Route path="/client_list" element={<ClientList />} />
                    <Route path="/department_list" element={<DepartmentList />} />
                    <Route path="/vendor_list" element={<VendorList />} />
                    <Route path="/implementer_list" element={<OrganizationProfileList />} />
                    <Route path="/job_description" element={<JobDescription />} />
                    <Route path="/imp_departments" element={<ImpDepartmentList />} />
                    <Route path="/linkedin/callback" element={<LinkedInCallback />} />
                    <Route path="/portal_config" element={<PortalConfig />} />
                    <Route path="/candidate_profile" element={<CandidateProfile />} />
                    <Route path="/jd/:jdId/matched-profiles" element={<MatchedProfilesPage />} />
                    <Route path="/candidate-action/:token" element={<CandidateActionPage />} />
                    <Route path="/shortlist-details/:token" element={<ShortlistDetailsForm />} />
                    <Route path="/schedule-interview/:token" element={<ScheduleInterview />} />
                    <Route path="/resume/:resume_id/matched-profiles-candidate" element={<MatchedProfilesCandidate />} />
                    <Route path="/audit_logs" element={<AuditLogs />} />
                    <Route path="/mail_read_status" element={<MailReadStatus />} />
                    <Route path="/scraping_progress_table" element={<ScrapingProgressTable />} />
                    <Route path="/logout" element={<Logout />} />
                </Routes>
            </AuthGuard>
        </MainLayout>
    );
};

export default MainRoutes;
